<template>
	<div>
		<div class="detail-infos">
			累计现金流在第<span class="special">{{ year || '-' }}</span
			>年回正
		</div>
		<a-table
			:columns="columns"
			:data-source="tableDatas"
			:pagination="false"
			bordered
		></a-table>
	</div>
</template>

<script setup>
	import { ref, defineProps, watch, onMounted } from "vue";
	// 引入公共方法
	import { toFixed } from "@/plugins/index.js";
	import { makeTotalData } from "../plugin";

	const props = defineProps({
		investorCashFlows: {
			type: Object,
			default: () => {
				return null;
			}
		},
		hasTax: {
			type: Boolean,
			default: () => {
				return false;
			}
		}
	});
	const columns = ref([]);
	const year = ref(null);
	const normalColumns = [
		{
			title: "年份",
			dataIndex: "year",
			key: "year"
		},
		{
			title: "放电收入(万元)",
			dataIndex: "dischargeProfit",
			key: "dischargeProfit"
		},
		{
			title: "运营支出(万元)",
			dataIndex: "operationOutput",
			key: "operationOutput"
		},
		{
			title: "净现金流(税前)(万元)",
			dataIndex: "cashFlow",
			key: "cashFlow"
		},
		{
			title: "累计净现金流(税前)(万元)",
			dataIndex: "totalCashFlow",
			key: "totalCashFlow"
		}
	];
	const hasTaxColumns = [
		{
			title: "年份",
			dataIndex: "year",
			key: "year"
		},
		{
			title: "放电收入(万元)",
			dataIndex: "dischargeProfit",
			key: "dischargeProfit"
		},
		{
			title: "运营支出(万元)",
			dataIndex: "operationOutput",
			key: "operationOutput"
		},
		{
			title: "税费支出(万元)",
			dataIndex: "taxOutput",
			key: "taxOutput"
		},
		{
			title: "净现金流(万元)",
			dataIndex: "cashFlow",
			key: "cashFlow"
		},
		{
			title: "累计净现金流(万元)",
			dataIndex: "totalCashFlow",
			key: "totalCashFlow"
		}
	];
	const tableDatas = ref([]);

	// 生成数据
	const makeTableData = (lists = []) => {
		let arr = [];
		lists.map((el, index) => {
			arr.push({
				year: index,
				dischargeProfit: toFixed(el.dischargeProfit / 10000),
				operationOutput: toFixed(el.operationOutput / 10000),
				taxOutput: toFixed(el.taxOutput / 10000),
				cashFlow: toFixed(el.cashFlow / 10000),
				totalCashFlow: toFixed(el.totalCashFlow / 10000)
			});

			console.log(el.totalCashFlow > 0 && year.value);
			console.log(el.totalCashFlow, year.value);
			if (el.totalCashFlow > 0 && year.value == null) {
				year.value = index;
			}
		});

		let totalRow = makeTotalData(
			lists,
			["dischargeProfit", "operationOutput", "taxOutput"],
			["cashFlow", "totalCashFlow"]
		);
		tableDatas.value = [...arr, totalRow];
	};

	watch(
		() => props.investorCashFlows,
		newVal => {
			console.log(newVal);
			if (newVal) {
				// 生成数据
				makeTableData(newVal);
			}
		},
		{ immediate: true, deep: true }
	);

	// 监听添加税列信息
	watch(
		() => props.hasTax,
		newVal => {
			if (newVal) {
				columns.value = hasTaxColumns;
			} else {
				columns.value = normalColumns;
			}
		},
		{ immediate: true, deep: true }
	);
</script>

<style lang="less" scoped>
	.detail-infos {
		color: #000000d9;
		font-size: 16px;
		font-family: PingFangSC;
		font-weight: 400;
		line-height: 24px;
		letter-spacing: 0;
		text-align: justify;
		margin-bottom: 8px;
		.special {
			color: #0058fc;
			font-weight: 500;
		}
	}
    ::v-deep .ant-table-cell {
        padding: 11px 16px !important;
    }
</style>
